import { checkMatricula, finishMatricula } from "@/api/prematriculas.api"

const state = {

    total: 0,
    prematricula: null,
    iban: {},
    pagoTipo: null,
    pagoMetodo: null,
    matriculaAlumnos: [],
    matriculas: []

}

const getters = {

    /**
     * Return Total
     * 
     */

    getMatriculaTotal(state) {

        return state.total

    },

    /**
     * Return Alumnos
     * 
     */

    getMatriculaAlumnos(state) {

        return state.matriculaAlumnos

    },

    /**
     * Get payment type
     * 
     */

    getPaymentType(state) {

        return state.pagoTipo

    }

}

const actions = {

    /**
     * Set Total
     * @param total Integer
     * 
     */

    setTotal({ commit }, total){

        commit( 'SET_TOTAL', total )

    },

    /**
     * Set Solicitante
     * @param solicitante Integer
     * 
     */

    setSolicitante({ commit }, solicitante){

        commit( 'SET_SOLICITANTE', solicitante )

    },

    /**
     * Set Prematricula
     * @param prematricula Integer
     * 
     */

    setPrematricula({ commit }, prematricula){

        commit( 'SET_PREMATRICULA', prematricula )

    },

    /**
     * Set Iban
     * @param iban Object
     * 
     */

    setIban({ commit }, iban){

        commit( 'SET_IBAN', iban )

    },

    /**
     * Set Pago tipo
     * @param pagoTipo integer
     * 
     */

    setPagoTipo({ commit }, pagoTipo){

        commit( 'SET_PAGOTIPO', pagoTipo )

    },

    /**
     * Set Pago metodo
     * @param pagoMetodo integer
     * 
     */

    setPagoMetodo({ commit }, pagoMetodo){

        commit( 'SET_PAGOMETODO', pagoMetodo )

    },

    /**
     * Post data when back from the TPV
     * 
     */
    async tpvBackPostData( { dispatch }, { numeroPedido, code, componentId } ) {

        try {

            const query = await finishMatricula( numeroPedido, code )

            //console.log( query.data )

            if(query.status == 200) {

                return query.data

            } else {

                dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

                return false

            }

        } catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')
            
            let errorCode = 'CODE01'

            if(error.response.data.code == 500) errorCode = 'CODE06'

            dispatch('Errors/setError', { error: errorCode, componentId: componentId }, { root: true })

            return false

        }

    },

    /**
     * Post matricula to API
     * 
     */

    async checkMatricula({ dispatch, commit, state }, { componentId } ) {

        let matriculaPost =  {

            importe: state.total,
            prematricula: state.prematricula,
            pagoTipo: state.pagoTipo,
            pagoMetodo: state.pagoMetodo,
            matriculas: state.matriculas

        }

        if( state.pagoMetodo == 2) {

            matriculaPost.iban = state.iban

        }

        try {

            const query = await checkMatricula(matriculaPost)

            if(query.status == 200) {

                return query.data

            } else {

                dispatch('Errors/setError', { error:'CODE02', componentId: componentId }, { root: true })

                return false

            }

        } catch (error) {

            //console.log(error.response.data.code)
            //console.log('handle errors')

            dispatch('Errors/setError', { error:'CODE01', componentId: componentId }, { root: true })

            return false

        }
        

    },

    /**
     * Add alumno data
     * @param alumno Object
     * 
     */

    addMatriculaAlumno({ commit, state }, alumno){

        let alumnoExists = state.matriculaAlumnos.find( a => a.id === alumno.id )

        if( typeof alumnoExists !== 'undefined' ) {

            let index = state.matriculaAlumnos.indexOf(alumnoExists)
            
            let matriculas = state.matriculaAlumnos[index].matriculas

            let matriculaExists = matriculas.find( a => a.nivel === alumno.matricula.nivel )

            if( typeof matriculaExists !== 'undefined' ) {

                let indexMatricula = matriculas.indexOf(matriculaExists)
                
                state.matriculaAlumnos[index].matriculas.splice(indexMatricula, 1)

                state.matriculas[index].matriculas.splice(indexMatricula, 1)

            }

            state.matriculaAlumnos[index].matriculas.push(alumno.matricula)
            state.matriculas[index].matriculas.push( { grupo: alumno.matricula.group } )

        } else {

            let alumnoMatricula = {
                
                id: alumno.id,
                name: alumno.name,
                matriculas: [alumno.matricula]

            }

            commit( 'ADD_ALUMNO', alumnoMatricula )

            let matricula = {

                alumno: alumno.id,
                matriculas: [{grupo: alumno.matricula.group}]

            }

            commit( 'ADD_MATRICULA', matricula )

        }

    },

    /**
     * Remove alumno data
     * @param alumno Object
     * 
     */

    removeMatriculaAlumno({ commit, state }, alumno) {

        let alumnoExists = state.matriculaAlumnos.find( a => a.id === alumno.id )

        if( typeof alumnoExists !== 'undefined' ) {

            let index = state.matriculaAlumnos.indexOf(alumnoExists)
            
            let matriculas = state.matriculaAlumnos[index].matriculas

            let matriculaExists = matriculas.find( a => a.nivel === alumno.nivel )

            if( typeof matriculaExists !== 'undefined' ) {

                let indexMatricula = matriculas.indexOf(matriculaExists)
                
                state.matriculaAlumnos[index].matriculas.splice(indexMatricula, 1)

            }

        }

    },

    /**
     * Remove group from alumno matriculas, if no groups remove the alumno
     * @param alumnoId Integer
     * @param groupId Integer
     */

    removeGroupFromAlumno( { commit, state }, {alumnoId,groupId} ) {

        // Remove group from matriculaAlumnos

        let alumnoExists = state.matriculaAlumnos.find( a => a.id === alumnoId )

        if( typeof alumnoExists !== 'undefined' ) {

            let index = state.matriculaAlumnos.indexOf(alumnoExists)
            
            let matriculas = state.matriculaAlumnos[index].matriculas

            let matriculaExists = matriculas.find( a => a.group === groupId )

            if( typeof matriculaExists !== 'undefined' ) {

                let indexMatricula = matriculas.indexOf(matriculaExists)
                
                state.matriculaAlumnos[index].matriculas.splice(indexMatricula, 1)

            }

            // If alumno no has groups remove alumno
            if( state.matriculaAlumnos[index].matriculas.length == 0) state.matriculaAlumnos.splice(index, 1)

        }

        // Remove group from matriculas

        let alumnoMExists = state.matriculas.find( a => a.alumno === alumnoId )

        if( typeof alumnoMExists !== 'undefined' ) {

            let indexM = state.matriculas.indexOf(alumnoMExists)
            
            let matriculasM = state.matriculas[indexM].matriculas

            let matriculaExistsM = matriculasM.find( a => a.grupo === groupId )

            if( typeof matriculaExistsM !== 'undefined' ) {

                let indexMatriculaM = matriculasM.indexOf(matriculaExistsM)
                
                state.matriculas[indexM].matriculas.splice(indexMatriculaM, 1)

            }

            // If alumno no has groups remove alumno
            if( state.matriculas[indexM].matriculas.length == 0) state.matriculas.splice(indexM, 1)

        }

    }

}

const mutations = {

    /**
     * Set Total
     * 
     */

    SET_TOTAL(state, total) {

        state.total = total

    },

    /**
     * Set Solicitante
     * 
     */

    SET_SOLICITANTE(state, solicitante) {

        state.solicitante = solicitante

    },

    /**
     * Set Prematricula
     * 
     */

    SET_PREMATRICULA(state, prematricula) {

        state.prematricula = prematricula

    },

    /**
     * Set Iban
     * 
     */

    SET_IBAN(state, iban) {

        state.iban = iban

    },

    /**
     * Set Pago tipo
     * 
     */

    SET_PAGOTIPO(state, pagoTipo) {

        state.pagoTipo = pagoTipo

    },

    /**
     * Set Pago método
     * 
     */

    SET_PAGOMETODO(state, pagoMetodo) {

        state.pagoMetodo = pagoMetodo

    },

    /**
     * Add alumno
     * 
     */

    ADD_ALUMNO(state, alumno) {

        state.matriculaAlumnos.push(alumno)

    },

    /**
     * Add matricula
     * 
     */

    ADD_MATRICULA(state, matricula) {

        state.matriculas.push(matricula)

    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}